import translate from "@insite/client-framework/Translate";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { ROLES_REQUIRING_APPROVER, USER_ROLES } from "@store/constants";
import { UserPolicyViewModel, UserRoleUpdateModel } from "@store/Types/User";

const splitChar = ",";

export const splitRoles = (roles?: string) => {
    return roles?.split(splitChar) || [];
};

export const joinRoles = (roles: string[]) => {
    return roles.join(splitChar) || "";
};

export const getPolicies = (user: AccountModel) => {
    return splitRoles((user as any).policies ?? user.properties.policies);
};

export const getAvailablePolicies = (user: AccountModel) => {
    return splitRoles(user.properties.availablePolicies);
};

export const getRole = (user: AccountModel) => {
    const roles = splitRoles(user.role);
    const availablePolicies = getAvailablePolicies(user);
    return roles.filter(x => !availablePolicies.includes(x))[0] || "";
};

export const getRoleUpdateProps = (newRole: string, policies?: UserPolicyViewModel[]) => {
    const activePolicies = policies?.filter(x => x.active).map(x => x.name) || [];

    return {
        role: joinRoles(newRole ? [newRole, ...activePolicies] : activePolicies),
        policies: joinRoles(activePolicies),
    } as UserRoleUpdateModel;
};

export const mapToUserPolicyViewModel = (user: AccountModel, getActiveState = true) => {
    const activePolicies = getActiveState ? getPolicies(user) : [];

    return (
        getAvailablePolicies(user).map(policy => ({
            label: translate(`${policy}_UserPolicy`),
            name: policy,
            active: activePolicies.includes(policy),
        })) || []
    );
};

export const canSeePolicies = (userRoles: string, role?: string) => {
    return (
        userRoles && userRoles.includes(USER_ROLES.administrator) && role !== "" && role !== USER_ROLES.administrator
    );
};

export const canSeeApprover = (role: string) => {
    return ROLES_REQUIRING_APPROVER.includes(role);
};
